import React from 'react';
import styles from './CadSubjectsInformation.module.scss';
import { CadSubjectValueType } from '../../../../../Models/CadReportValue';
import {
  FieldItemList,
  FieldItemListType
} from '../../CommonBody/FieldItemList/FieldItemList';

const getSubjectFields = (
  subject: CadSubjectValueType
): FieldItemListType[] => {
  let subjectFields: FieldItemListType[] = [];

  if (subject.age) {
    subjectFields.push({
      label: 'Age',
      value: subject.age,
      type: 'number'
    });
  }

  if (subject.gender) {
    subjectFields.push({
      label: 'Gender',
      value: subject.gender,
      type: 'string'
    });
  }

  if (subject.race_ethnicity && subject.race_ethnicity.length > 0) {
    subjectFields.push({
      label: 'Race/Ethnicity',
      value: subject.race_ethnicity.join(', '),
      type: 'string'
    });
  }

  if (subject.race) {
    subjectFields.push({
      label: 'Race',
      value: subject.race,
      type: 'string'
    });
  }

  if (subject.ethnicity) {
    subjectFields.push({
      label: 'Ethnicity',
      value: subject.ethnicity,
      type: 'string'
    });
  }

  if (subject.dob) {
    subjectFields.push({
      label: 'D.O.B',
      value: subject.dob,
      type: 'exactdate'
    });
  }

  if (subject.resident_status) {
    subjectFields.push({
      label: 'Resident Status',
      value: subject.resident_status,
      type: 'string'
    });
  }

  if (subject.role) {
    subjectFields.push({
      label: 'Role',
      value: subject.role,
      type: 'string'
    });
  }

  return subjectFields;
};

export interface CadSubjectsInformationProps {
  subjects?: CadSubjectValueType[];
}

export const CadSubjectsInformation = ({
  subjects
}: CadSubjectsInformationProps): React.ReactElement<CadSubjectsInformationProps> => {
  return (
    <div className={styles.cadSubjectsInformation}>
      <h3 className={styles.title}>Subjects Information</h3>
      <div className={styles.items}>
        {subjects?.map((subject, index) => (
          <FieldItemList
            key={subject.id}
            title={`${[subject.first_name, subject.middle_name, subject.last_name].join(' ')}`}
            fields={getSubjectFields(subject as CadSubjectValueType)}
            hasDivider={index < subjects.length - 1}
          />
        ))}
      </div>
    </div>
  );
};
